import React, { useCallback, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import GroupPanel from './components/GroupPanel'
import effects from 'app/effects/effects'
import { useIntl } from 'react-intl'
import { usePlace } from 'commons/usePlace'
import MessageAlert from 'app/components/MessageAlert'
import './style.css'
import { HOMELESS_GROUP } from 'commons/groupLogic'
import { GROUPS_DELETE_REQUEST, GROUPS_CREATE_FETCH_REQUEST } from './actions'
import * as R from 'ramda'
import { Routes } from 'app/services/routeService/routeService'
import { useConversationSocket } from 'app/main/messages/conversations/useConversationSocket'
import { useAccessControl } from 'app/auth/useAccessControl'
import { AccessType } from 'app/auth/accessControlService'
import { SocketEvent } from 'app/main/messages/conversations/socket'

const Group = ({
  parentState,
  history,
  pageData,
  setParentState,
  setGroupList,
  setSubscriberList,
  initParentState,
}) => {
  const initPageState = {
    searchState: false,
    searchText: '',
    selected: {},
    selectAll: false,
    isOpenDeleteDialog: false,
    isOpenCreateDialog: false,
    deletedGroupId: null,
    deleteDialogMsg: '',
    subgroups: [],
    isDisableSubmitBtn: true,
    newGroupNameTmp: '',
    errorMsg: {},
  }

  const [pageState, setPageState] = useState(initPageState)
  const [reRenderPage, setReRenderPage] = useState('')
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const { handleRecordUpdates } = useConversationSocket()

  const place = usePlace()
  const { id: placeId } = place

  const apiFetchersCallback = useCallback(
    (fetchType, perams) => {
      let fetch = () =>
        effects.apis.groups({ placeId, limit: 1, type: `${HOMELESS_GROUP}` })
      if (fetchType === GROUPS_DELETE_REQUEST) {
        fetch = () => effects.apis.deleteGroups(perams)
      } else if (fetchType === GROUPS_CREATE_FETCH_REQUEST) {
        fetch = () => effects.apis.createGroup(perams)
      }
      return fetch()
    },
    [placeId],
  )

  useEffect(() => {
    setPageState(initPageState)
    setParentState({
      ...parentState,
      selectedGroup: false,
    })
    pageData.refetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  function deleteGroups(groupsIds) {
    apiFetchersCallback(GROUPS_DELETE_REQUEST, { groupIds: groupsIds })
      .then((data) => {
        setReRenderPage(new Date().getMilliseconds())

        groupsIds.forEach((groupId) => {
          handleRecordUpdates(SocketEvent.UPDATE_GROUP, groupId, placeId)
        })

        showSnackbar(
          formatMessage(
            { id: 'group.success.deleteSuccessfully' },
            {
              groupLength: R.length(groupsIds),
            },
          ),
        )

        let newPage = pageData.pageInfo.page - 1
        if (
          newPage >= 0 &&
          pageData.pageInfo.data.length - groupsIds.length <= 0
        ) {
          pageData.pageInfo.page = newPage
        }

        pageData.startFetchData()
        pageData.refetchData()
      })
      .catch((error) =>
        dispatch(MessageAlert.showNetworkError(formatMessage)(error)),
      )
  }

  function createGroup(postData) {
    postData['placeId'] = placeId

    apiFetchersCallback(GROUPS_CREATE_FETCH_REQUEST, postData)
      .then((data) => {
        showSnackbar(formatMessage({ id: 'group.success_msg_6' }))
        pageData.startFetchData()
        pageData.refetchData()
      })
      .catch((error) => {
        let { details } = error.response.data
        if (details) {
          dispatch(MessageAlert.showNetworkError(formatMessage)(error))
        }
      })
  }

  function showSnackbar(msg) {
    dispatch(MessageAlert.showSuccess({ message: msg }))
  }
  let { isGranted } = useAccessControl([
    AccessType.ADMINISTRATION,
    AccessType.SUBSCRIBER_VIEW,
  ])
  function handleViewGroupDetail(id) {
    if (isGranted) {
      history.push(Routes.viewGroups(id))
    }
    return false
  }

  return (
    <GroupPanel
      apiFetchersCallback={apiFetchersCallback}
      setParentState={setParentState}
      setGroupList={setGroupList}
      setSubscriberList={setSubscriberList}
      initParentState={initParentState}
      parentState={parentState}
      deleteGroupsRequest={deleteGroups}
      createGroupRequest={createGroup}
      pageState={pageState}
      setPageState={setPageState}
      pageData={pageData}
      reRenderPage={reRenderPage}
      onViewGroup={handleViewGroupDetail}
      history={history}
    />
  )
}

export default Group
